import { render } from "./TpProdutoMapaSelect.vue?vue&type=template&id=2ec5eddf"
import script from "./TpProdutoMapaSelect.vue?vue&type=script&lang=js"
export * from "./TpProdutoMapaSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__